"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var OrderContext = /*#__PURE__*/React.createContext(null);
var _default = OrderContext;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rc-component/portal/lib/Context.js
// module id = 851
// module chunks = 0